<template>
  <div>
    <!-- PROFILE -->
    <div v-if="log.log_type === 'worker' && log.type === 'created' && model_log === 'Profile' && new_values !== null" class="record">
      <div v-if="new_values.title !== null" class="row">
        <div class="col-5"><strong>Title</strong></div>
        <div class="col-7">{{ new_values.title }}</div>
      </div>
      <div v-if="new_values.first_name !== null" class="row">
        <div class="col-5"><strong>First Name</strong></div>
        <div class="col-7">{{ new_values.first_name }}</div>
      </div>
      <div v-if="new_values.surname !== null" class="row">
        <div class="col-5"><strong>Surname</strong></div>
        <div class="col-7">{{ new_values.surname }}</div>
      </div>
      <div v-if="new_values.dob !== null" class="row">
        <div class="col-5"><strong>D.O.B</strong></div>
        <div class="col-7">{{ new_values.dob | formatDate }}</div>
      </div>
      <div v-if="new_values.nationality !== null" class="row">
        <div class="col-5"><strong>Nationality</strong></div>
        <div class="col-7">{{ new_values.nationality }}</div>
      </div>
      <div v-if="new_values.ni_number !== null" class="row">
        <div class="col-5"><strong>NI Number</strong></div>
        <div class="col-7">{{ new_values.ni_number }}</div>
      </div>
      <div v-if="new_values.utr_number !== null" class="row">
        <div class="col-5"><strong>Personal UTR Number</strong></div>
        <div class="col-7">{{ new_values.utr_number }}</div>
      </div>
      <div v-if="new_values.industry !== null" class="row">
        <div class="col-5"><strong>Industry</strong></div>
        <div class="col-7">{{ new_values.industry }}</div>
      </div>
      <div v-if="new_values.job_title !== null" class="row">
        <div class="col-5"><strong>Job Title</strong></div>
        <div class="col-7">{{ new_values.job_title }}</div>
      </div>
      <div v-if="new_values.email !== null" class="row">
        <div class="col-5"><strong>Email</strong></div>
        <div class="col-7">{{ new_values.email }}</div>
      </div>
      <div v-if="new_values.mobile !== null" class="row">
        <div class="col-5"><strong>Mobile</strong></div>
        <div class="col-7">{{ new_values.mobile }}</div>
      </div>
      <div v-if="new_values.telephone !== null" class="row">
        <div class="col-5"><strong>Landline Number</strong></div>
        <div class="col-7">{{ new_values.telephone }}</div>
      </div>
      <div v-if="new_values.full_personal_address !== null" class="row">
        <div class="col-5"><strong>Personal Address</strong></div>
        <div class="col-7">{{ new_values.full_personal_address }}</div>
      </div>
      <div v-if="new_values.nok_name !== null" class="row">
        <div class="col-5"><strong>NOK Name</strong></div>
        <div class="col-7">{{ new_values.nok_name }}</div>
      </div>
      <div v-if="new_values.nok_number !== null" class="row">
        <div class="col-5"><strong>NOK Number</strong></div>
        <div class="col-7">{{ new_values.nok_number }}</div>
      </div>
      <div v-if="new_values.bank_name !== null" class="row">
        <div class="col-5"><strong>Personal Bank Name</strong></div>
        <div class="col-7">{{ new_values.bank_name }}</div>
      </div>
      <div v-if="new_values.branch_location !== null" class="row">
        <div class="col-5"><strong>Branch Location</strong></div>
        <div class="col-7">{{ new_values.branch_location }}</div>
      </div>
      <div v-if="new_values.bank_account_holder !== null" class="row">
        <div class="col-5"><strong>Bank Account Holder</strong></div>
        <div class="col-7">{{ new_values.bank_account_holder }}</div>
      </div>
      <div v-if="new_values.bank_account_number !== null" class="row">
        <div class="col-5"><strong>Bank Account Number</strong></div>
        <div class="col-7">{{ new_values.bank_account_number }}</div>
      </div>
      <div v-if="new_values.bank_sort_code !== null" class="row">
        <div class="col-5"><strong>Bank Sort Code</strong></div>
        <div class="col-7">{{ new_values.bank_sort_code }}</div>
      </div>
      <div v-if="new_values.bsoc_ref !== null" class="row">
        <div class="col-5"><strong>Building Society Ref</strong></div>
        <div class="col-7">{{ new_values.bsoc_ref }}</div>
      </div>
    </div>
    <div v-if="(log.type === 'deleted' || log.type === 'restored' || log.type === 'updated') && model_log === 'Profile' && new_values !== null && old_values !== null"
         class="record">
      <div v-if="new_values !== null && 'title' in new_values" class="row">
        <div class="col-5"><strong>Title</strong></div>
        <div class="col-7">
          <div class="updated_value">{{ new_values.title }}</div>
          <div class="old_value">{{ old_values.title }}</div>
        </div>
      </div>
      <div v-if="new_values !== null && 'first_name' in new_values" class="row">
        <div class="col-5"><strong>First Name</strong></div>
        <div class="col-7">
          <div class="updated_value">{{ new_values.first_name }}</div>
          <div class="old_value">{{ old_values.first_name }}</div>
        </div>
      </div>
      <div v-if="new_values !== null && 'surname' in new_values" class="row">
        <div class="col-5"><strong>Surname</strong></div>
        <div class="col-7">
          <div class="updated_value">{{ new_values.surname }}</div>
          <div class="old_value">{{ old_values.surname }}</div>
        </div>
      </div>
      <div v-if="new_values !== null && 'dob' in new_values" class="row">
        <div class="col-5"><strong>D.O.B</strong></div>
        <div class="col-7">
          <div class="updated_value">{{ new_values.dob | formatDate }}</div>
          <div class="old_value">{{ old_values.dob | formatDate }}</div>
        </div>
      </div>
      <div v-if="new_values !== null && 'nationality' in new_values" class="row">
        <div class="col-5"><strong>Nationality</strong></div>
        <div class="col-7">
          <div class="updated_value">{{ new_values.nationality }}</div>
          <div class="old_value">{{ old_values.nationality }}</div>
        </div>
      </div>
      <div v-if="new_values !== null && 'ni_number' in new_values" class="row">
        <div class="col-5"><strong>NI Number</strong></div>
        <div class="col-7">
          <div class="updated_value">{{ new_values.ni_number }}</div>
          <div class="old_value">{{ old_values.ni_number }}</div>
        </div>
      </div>
      <div v-if="new_values !== null && 'utr_number' in new_values" class="row">
        <div class="col-5"><strong>Personal UTR Number</strong></div>
        <div class="col-7">
          <div class="updated_value">{{ new_values.utr_number }}</div>
          <div class="old_value">{{ old_values.utr_number }}</div>
        </div>
      </div>
      <div v-if="new_values !== null && 'industry' in new_values" class="row">
        <div class="col-5"><strong>Industry</strong></div>
        <div class="col-7">
          <div class="updated_value">{{ new_values.industry }}</div>
          <div class="old_value">{{ old_values.industry }}</div>
        </div>
      </div>
      <div v-if="new_values !== null && 'job_title' in new_values" class="row">
        <div class="col-5"><strong>Job Title</strong></div>
        <div class="col-7">
          <div class="updated_value">{{ new_values.job_title }}</div>
          <div class="old_value">{{ old_values.job_title }}</div>
        </div>
      </div>
      <div v-if="new_values !== null && 'email' in new_values" class="row">
        <div class="col-5"><strong>Email</strong></div>
        <div class="col-7">
          <div class="updated_value">{{ new_values.email }}</div>
          <div class="old_value">{{ old_values.email }}</div>
        </div>
      </div>
      <div v-if="new_values !== null && 'mobile' in new_values" class="row">
        <div class="col-5"><strong>Mobile</strong></div>
        <div class="col-7">
          <div class="updated_value">{{ new_values.mobile }}</div>
          <div class="old_value">{{ old_values.mobile }}</div>
        </div>
      </div>
      <div v-if="new_values !== null && 'telephone' in new_values" class="row">
        <div class="col-5"><strong>Landline Number</strong></div>
        <div class="col-7">
          <div class="updated_value">{{ new_values.telephone }}</div>
          <div class="old_value">{{ old_values.telephone }}</div>
        </div>
      </div>
      <div v-if="new_values !== null && 'full_personal_address' in new_values" class="row">
        <div class="col-5"><strong>Personal Address</strong></div>
        <div class="col-7">
          <div class="updated_value">{{ new_values.full_personal_address }}</div>
          <div class="old_value">{{ old_values.full_personal_address }}</div>
        </div>
      </div>
      <div v-if="new_values !== null && 'nok_name' in new_values" class="row">
        <div class="col-5"><strong>NOK Name</strong></div>
        <div class="col-7">
          <div class="updated_value">{{ new_values.nok_name }}</div>
          <div class="old_value">{{ old_values.nok_name }}</div>
        </div>
      </div>
      <div v-if="new_values !== null && 'nok_number' in new_values" class="row">
        <div class="col-5"><strong>NOK Number</strong></div>
        <div class="col-7">
          <div class="updated_value">{{ new_values.nok_number }}</div>
          <div class="old_value">{{ old_values.nok_number }}</div>
        </div>
      </div>
      <div v-if="new_values !== null && 'bank_name' in new_values" class="row">
        <div class="col-5"><strong>Personal Bank Name</strong></div>
        <div class="col-7">
          <div class="updated_value">{{ new_values.bank_name }}</div>
          <div class="old_value">{{ old_values.bank_name }}</div>
        </div>
      </div>
      <div v-if="new_values !== null && 'branch_location' in new_values" class="row">
        <div class="col-5"><strong>Branch Location</strong></div>
        <div class="col-7">
          <div class="updated_value">{{ new_values.branch_location }}</div>
          <div class="old_value">{{ old_values.branch_location }}</div>
        </div>
      </div>
      <div v-if="new_values !== null && 'bank_account_holder' in new_values" class="row">
        <div class="col-5"><strong>Bank Account Holder</strong></div>
        <div class="col-7">
          <div class="updated_value">{{ new_values.bank_account_holder }}</div>
          <div class="old_value">{{ old_values.bank_account_holder }}</div>
        </div>
      </div>
      <div v-if="new_values !== null && 'bank_account_number' in new_values" class="row">
        <div class="col-5"><strong>Bank Account Number</strong></div>
        <div class="col-7">
          <div class="updated_value">{{ new_values.bank_account_number }}</div>
          <div class="old_value">{{ old_values.bank_account_number }}</div>
        </div>
      </div>
      <div v-if="new_values !== null && 'bank_sort_code' in new_values" class="row">
        <div class="col-5"><strong>Bank Sort Code</strong></div>
        <div class="col-7">
          <div class="updated_value">{{ new_values.bank_sort_code }}</div>
          <div class="old_value">{{ old_values.bank_sort_code }}</div>
        </div>
      </div>
      <div v-if="new_values !== null && 'bsoc_ref' in new_values" class="row">
        <div class="col-5"><strong>Building Society Ref</strong></div>
        <div class="col-7">
          <div class="updated_value">{{ new_values.bsoc_ref }}</div>
          <div class="old_value">{{ old_values.bsoc_ref }}</div>
        </div>
      </div>
    </div>

    <!-- APPLICATIONS -->
    <div v-if="log.log_type === 'worker' && log.type === 'created' && model_log === 'Application' && new_values !== null" class="record"></div>

    <!-- ASSIGNMENTS -->
    <div v-if="log.log_type === 'worker' && log.type === 'created' && model_log === 'Assignment' && new_values !== null" class="record"></div>

    <!-- COMPANY/STATUS -->
    <div v-if="log.log_type === 'worker' && log.type === 'created' && model_log === 'Company/Status' && new_values !== null" class="record">
      <div v-if="new_values.employment_type !== null" class="row">
        <div class="col-5"><strong>Employment Status</strong></div>
        <div class="col-7">{{ new_values.employment_type }}</div>
      </div>
      <div v-if="new_values.company_trading_name !== null" class="row">
        <div class="col-5"><strong>Trading Name</strong></div>
        <div class="col-7">{{ new_values.company_trading_name }}</div>
      </div>
      <div v-if="new_values.company_utr_number !== null" class="row">
        <div class="col-5"><strong>Company UTR Number</strong></div>
        <div class="col-7">{{ new_values.company_utr_number }}</div>
      </div>
      <div v-if="new_values.company_ltd_reg_number !== null" class="row">
        <div class="col-5"><strong>LTD Reg Number</strong></div>
        <div class="col-7">{{ new_values.company_ltd_reg_number }}</div>
      </div>
      <div v-if="new_values.company_vat_registered !== null" class="row">
        <div class="col-5"><strong>VAT Registered</strong></div>
        <div class="col-7">
          <span v-if="new_values.company_vat_registered">Yes</span>
          <span v-else-if="!new_values.company_vat_registered">No</span>
        </div>
      </div>
      <div v-if="new_values.company_vat_number !== null" class="row">
        <div class="col-5"><strong>VAT Number</strong></div>
        <div class="col-7">{{ new_values.company_vat_number }}</div>
      </div>
      <div v-if="new_values.full_company_address !== null && !new_values.company_address_same_as_personal" class="row">
        <div class="col-5"><strong>Company Address</strong></div>
        <div class="col-7">{{ new_values.full_company_address }}</div>
      </div>
      <div v-if="new_values.company_bank_name !== null && !new_values.company_bank_same_as_personal" class="row">
        <div class="col-5"><strong>Company Bank Name</strong></div>
        <div class="col-7">{{ new_values.company_bank_name }}</div>
      </div>
      <div v-if="new_values.company_branch_location !== null && !new_values.company_bank_same_as_personal" class="row">
        <div class="col-5"><strong>Bank Branch Location</strong></div>
        <div class="col-7">{{ new_values.company_branch_location }}</div>
      </div>
      <div v-if="new_values.company_bank_account_holder !== null && !new_values.company_bank_same_as_personal" class="row">
        <div class="col-5"><strong>Company Bank Account Holder</strong></div>
        <div class="col-7">{{ new_values.company_bank_account_holder }}</div>
      </div>
      <div v-if="new_values.company_bank_account_number !== null && !new_values.company_bank_same_as_personal" class="row">
        <div class="col-5"><strong>Company Bank Account Number</strong></div>
        <div class="col-7">{{ new_values.company_bank_account_number }}</div>
      </div>
      <div v-if="new_values.company_sort_code !== null && !new_values.company_bank_same_as_personal" class="row">
        <div class="col-5"><strong>Company Bank Sort Code</strong></div>
        <div class="col-7">{{ new_values.company_sort_code }}</div>
      </div>
      <div v-if="new_values.company_bsoc_ref !== null && !new_values.company_bank_same_as_personal" class="row">
        <div class="col-5"><strong>Company Building Society Ref</strong></div>
        <div class="col-7">{{ new_values.company_bsoc_ref }}</div>
      </div>
    </div>
    <div v-if="(log.type === 'deleted' || log.type === 'restored' || log.type === 'updated') && model_log === 'Company/Status' && new_values !== null && old_values !== null" class="record">
      <div v-if="new_values !== null && 'employment_type' in new_values" class="row">
        <div class="col-5"><strong>Employment Status</strong></div>
        <div class="col-7">
          <div class="updated_value">{{ new_values.employment_type }}</div>
          <div class="old_value">{{ old_values.employment_type }}</div>
        </div>
      </div>
      <div v-if="new_values !== null && 'company_trading_name' in new_values" class="row">
        <div class="col-5"><strong>Trading Name</strong></div>
        <div class="col-7">
          <div class="updated_value">{{ new_values.company_trading_name }}</div>
          <div class="old_value">{{ old_values.company_trading_name }}</div>
        </div>
      </div>
      <div v-if="new_values !== null && 'company_utr_number' in new_values" class="row">
        <div class="col-5"><strong>Company UTR Number</strong></div>
        <div class="col-7">
          <div class="updated_value">{{ new_values.company_utr_number }}</div>
          <div class="old_value">{{ old_values.company_utr_number }}</div>
        </div>
      </div>
      <div v-if="new_values !== null && 'company_ltd_reg_number' in new_values" class="row">
        <div class="col-5"><strong>LTD Reg Number</strong></div>
        <div class="col-7">
          <div class="updated_value">{{ new_values.company_ltd_reg_number }}</div>
          <div class="old_value">{{ old_values.company_ltd_reg_number }}</div>
        </div>
      </div>
      <div v-if="new_values !== null && 'company_vat_registered' in new_values" class="row">
        <div class="col-5"><strong>VAT Registered</strong></div>
        <div class="col-7">
          <div class="updated_value">
            <span v-if="new_values.company_vat_registered">Yes</span>
            <span v-else-if="!new_values.company_vat_registered">No</span>
          </div>
          <div class="old_value">
            <span v-if="old_values.company_vat_registered">Yes</span>
            <span v-else-if="!old_values.company_vat_registered">No</span>
          </div>
        </div>
      </div>
      <div v-if="new_values !== null && 'company_vat_number' in new_values" class="row">
        <div class="col-5"><strong>VAT Number</strong></div>
        <div class="col-7">
          <div class="updated_value">{{ new_values.company_vat_number }}</div>
          <div class="old_value">{{ old_values.company_vat_number }}</div>
        </div>
      </div>
      <div v-if="new_values !== null && 'company_address_same_as_personal' in new_values">
        <div class="row">
          <div class="col-5"><strong>Company Address same as Personal</strong></div>
          <div class="col-7">
            <div class="updated_value">
              <span v-if="new_values.company_address_same_as_personal">Yes</span>
              <span v-else-if="!new_values.company_address_same_as_personal">No</span>
            </div>
            <div class="old_value" v-if="'company_address_same_as_personal' in old_values">
              <span v-if="old_values.company_address_same_as_personal">Yes</span>
              <span v-else-if="!old_values.company_address_same_as_personal">No</span>
            </div>
          </div>
        </div>
        <div v-if="new_values !== null && 'full_company_address' in new_values" class="row">
          <div class="col-5"><strong>Company Address</strong></div>
          <div class="col-7">
            <div class="updated_value">{{ new_values.full_company_address }}</div>
            <div class="old_value">{{ old_values.full_company_address }}</div>
          </div>
        </div>
      </div>

      <div v-if="old_values !== null" class="row">
        <div class="col-12">
          <hr class="mt-2 mb-2">
        </div>
        <div class="col-5"><strong>Is Company Bank same as Personal</strong></div>
        <div class="col-7">
          <div class="">
            <span v-if="old_values.company_bank_same_as_personal">Yes</span>
            <span v-else-if="!old_values.company_bank_same_as_personal">No</span>
          </div>
        </div>
        <div class="col-12">
          <hr class="mt-2 mb-2">
        </div>
      </div>

      <div v-if="new_values !== null && 'company_bank_same_as_personal' in new_values" class="row">
        <div class="col-5"><strong>Company Bank same as Personal</strong></div>
        <div class="col-7">
          <div class="updated_value">
            <span v-if="new_values.company_bank_same_as_personal">Yes</span>
            <span v-else-if="!new_values.company_bank_same_as_personal">No</span>
          </div>
          <div class="old_value" v-if="'company_bank_same_as_personal' in old_values">
            <span v-if="old_values.company_bank_same_as_personal">Yes</span>
            <span v-else-if="!old_values.company_bank_same_as_personal">No</span>
          </div>
        </div>
      </div>

      <div v-if="new_values !== null && 'company_bank_name' in new_values" class="row">
        <div class="col-5"><strong>Company Bank Name</strong></div>
        <div class="col-7">
          <div class="updated_value">{{ new_values.company_bank_name }}</div>
          <div class="old_value">{{ old_values.company_bank_name }}</div>
        </div>
      </div>
      <div v-if="new_values !== null && 'company_branch_location' in new_values" class="row">
        <div class="col-5"><strong>Bank Branch Location</strong></div>
        <div class="col-7">
          <div class="updated_value">{{ new_values.company_branch_location }}</div>
          <div class="old_value">{{ old_values.company_branch_location }}</div>
        </div>
      </div>
      <div v-if="new_values !== null && 'company_bank_account_holder' in new_values" class="row">
        <div class="col-5"><strong>Company Bank Account Holder</strong></div>
        <div class="col-7">
          <div class="updated_value">{{ new_values.company_bank_account_holder }}</div>
          <div class="old_value">{{ old_values.company_bank_account_holder }}</div>
        </div>
      </div>
      <div v-if="new_values !== null && 'company_bank_account_number' in new_values" class="row">
        <div class="col-5"><strong>Company Bank Account Number</strong></div>
        <div class="col-7">
          <div class="updated_value">{{ new_values.company_bank_account_number }}</div>
          <div class="old_value">{{ old_values.company_bank_account_number }}</div>
        </div>
      </div>
      <div v-if="new_values !== null && 'company_sort_code' in new_values" class="row">
        <div class="col-5"><strong>Company Bank Sort Code</strong></div>
        <div class="col-7">
          <div class="updated_value">{{ new_values.company_sort_code }}</div>
          <div class="old_value">{{ old_values.company_sort_code }}</div>
        </div>
      </div>
      <div v-if="new_values !== null && 'company_bsoc_ref' in new_values" class="row">
        <div class="col-5"><strong>Company Building Society Ref</strong></div>
        <div class="col-7">
          <div class="updated_value">{{ new_values.company_bsoc_ref }}</div>
          <div class="old_value">{{ old_values.company_bsoc_ref }}</div>
        </div>
      </div>

    </div>

    <!-- ENTITY TEST -->
    <div v-if="log.log_type === 'worker' && log.type === 'created' && model_log === 'Entity Test' && new_values !== null" class="record">
      <div class="row">
        <div class="col-7"><strong>Using Limited Company</strong></div>
        <div class="col-5">{{ new_values.using_own_ltd_company }}</div>
      </div>
      <div class="row">
        <div class="col-7"><strong>UK Tax Payer</strong></div>
        <div class="col-5">{{ new_values.uk_tax_payer }}</div>
      </div>
      <div class="row">
        <div class="col-7"><strong>Can Send Substitute</strong></div>
        <div class="col-5">{{ new_values.send_substitution }}</div>
      </div>
      <div class="row">
        <div class="col-7"><strong>Subject to SDC</strong></div>
        <div class="col-5">{{ new_values.s_d_c }}</div>
      </div>
      <div class="row">
        <div class="col-7"><strong>Client switch between projects</strong></div>
        <div class="col-5">{{ new_values.switch_projects }}</div>
      </div>
      <div class="row">
        <div class="col-7"><strong>Contracted to named project</strong></div>
        <div class="col-5">{{ new_values.named_project }}</div>
      </div>
      <div class="row">
        <div class="col-7"><strong>Choose how work performed</strong></div>
        <div class="col-5">{{ new_values.how_work_performed }}</div>
      </div>
      <div class="row">
        <div class="col-7"><strong>Client decide working hours</strong></div>
        <div class="col-5">{{ new_values.decide_working_hours }}</div>
      </div>
      <div class="row">
        <div class="col-7"><strong>Notice Period Length</strong></div>
        <div class="col-5">{{ new_values.notice_period }}</div>
      </div>
      <div class="row">
        <div class="col-7"><strong>Obliged to take on work</strong></div>
        <div class="col-5">{{ new_values.offer_other_work }}</div>
      </div>
      <div class="row">
        <div class="col-7"><strong>Financially responsible to fix errors</strong></div>
        <div class="col-5">{{ new_values.correct_errors }}</div>
      </div>
      <div class="row">
        <div class="col-7"><strong>Current client last permanent employer</strong></div>
        <div class="col-5">{{ new_values.last_permanent_employer }}</div>
      </div>
      <div class="row">
        <div class="col-7"><strong>Entitled to : Sick Pay</strong></div>
        <div class="col-5">{{ new_values.sick_pay }}</div>
      </div>
      <div class="row">
        <div class="col-7"><strong>Entitled to : Holiday</strong></div>
        <div class="col-5">{{ new_values.holiday_entitlement }}</div>
      </div>
      <div class="row">
        <div class="col-7"><strong>Entitled to : Work Place Pension</strong></div>
        <div class="col-5">{{ new_values.work_place_pension }}</div>
      </div>
      <div class="row">
        <div class="col-7"><strong>Entitled to : Maternity / Paternity</strong></div>
        <div class="col-5">{{ new_values.maternity_paternity }}</div>
      </div>
      <div class="row">
        <div class="col-7"><strong>Received : Paid Training</strong></div>
        <div class="col-5">{{ new_values.paid_training }}</div>
      </div>
      <div class="row">
        <div class="col-7"><strong>Restricted from performing other work</strong></div>
        <div class="col-5">{{ new_values.restrict_other_work }}</div>
      </div>
      <div class="row">
        <div class="col-7"><strong>Spent own money on training</strong></div>
        <div class="col-5">{{ new_values.own_money_on_training }}</div>
      </div>
      <div class="row">
        <div class="col-7"><strong>Provide own equipment</strong></div>
        <div class="col-5">{{ new_values.provide_own_equipment }}</div>
      </div>
    </div>
    <div v-if="(log.type === 'deleted' || log.type === 'restored' || log.type === 'updated') && model_log === 'Entity Test' && new_values !== null && old_values !== null" class="record">
      <div v-if="new_values !== null && 'using_own_ltd_company' in new_values" class="row">
        <div class="col-7"><strong>Using Limited Company</strong></div>
        <div class="col-5">
          <div class="updated_value">{{ new_values.using_own_ltd_company }}</div>
          <div class="old_value">{{ old_values.using_own_ltd_company }}</div>
        </div>
      </div>
      <div v-if="new_values !== null && 'uk_tax_payer' in new_values" class="row">
        <div class="col-7"><strong>UK Tax Payer</strong></div>
        <div class="col-5">
          <div class="updated_value">{{ new_values.uk_tax_payer }}</div>
          <div class="old_value">{{ old_values.uk_tax_payer }}</div>
        </div>
      </div>
      <div v-if="new_values !== null && 'send_substitution' in new_values" class="row">
        <div class="col-7"><strong>Can Send Substitute</strong></div>
        <div class="col-5">
          <div class="updated_value">{{ new_values.send_substitution }}</div>
          <div class="old_value">{{ old_values.send_substitution }}</div>
        </div>
      </div>
      <div v-if="new_values !== null && 's_d_c' in new_values" class="row">
        <div class="col-7"><strong>Subject to SDC</strong></div>
        <div class="col-5">
          <div class="updated_value">{{ new_values.s_d_c }}</div>
          <div class="old_value">{{ old_values.s_d_c }}</div>
        </div>
      </div>
      <div v-if="new_values !== null && 'switch_projects' in new_values" class="row">
        <div class="col-7"><strong>Client switch between projects</strong></div>
        <div class="col-5">
          <div class="updated_value">{{ new_values.switch_projects }}</div>
          <div class="old_value">{{ old_values.switch_projects }}</div>
        </div>
      </div>
      <div v-if="new_values !== null && 'named_project' in new_values" class="row">
        <div class="col-7"><strong>Contracted to named project</strong></div>
        <div class="col-5">
          <div class="updated_value">{{ new_values.named_project }}</div>
          <div class="old_value">{{ old_values.named_project }}</div>
        </div>
      </div>
      <div v-if="new_values !== null && 'how_work_performed' in new_values" class="row">
        <div class="col-7"><strong>Choose how work performed</strong></div>
        <div class="col-5">
          <div class="updated_value">{{ new_values.how_work_performed }}</div>
          <div class="old_value">{{ old_values.how_work_performed }}</div>
        </div>
      </div>
      <div v-if="new_values !== null && 'decide_working_hours' in new_values" class="row">
        <div class="col-7"><strong>Client decide working hours</strong></div>
        <div class="col-5">
          <div class="updated_value">{{ new_values.decide_working_hours }}</div>
          <div class="old_value">{{ old_values.decide_working_hours }}</div>
        </div>
      </div>
      <div v-if="new_values !== null && 'notice_period' in new_values" class="row">
        <div class="col-7"><strong>Notice Period Length</strong></div>
        <div class="col-5">
          <div class="updated_value">{{ new_values.notice_period }}</div>
          <div class="old_value">{{ old_values.notice_period }}</div>
        </div>
      </div>
      <div v-if="new_values !== null && 'offer_other_work' in new_values" class="row">
        <div class="col-7"><strong>Obliged to take on work</strong></div>
        <div class="col-5">
          <div class="updated_value">{{ new_values.offer_other_work }}</div>
          <div class="old_value">{{ old_values.offer_other_work }}</div>
        </div>
      </div>
      <div v-if="new_values !== null && 'correct_errors' in new_values" class="row">
        <div class="col-7"><strong>Financially responsible to fix errors</strong></div>
        <div class="col-5">
          <div class="updated_value">{{ new_values.correct_errors }}</div>
          <div class="old_value">{{ old_values.correct_errors }}</div>
        </div>
      </div>
      <div v-if="new_values !== null && 'last_permanent_employer' in new_values" class="row">
        <div class="col-7"><strong>Current client last permanent employer</strong></div>
        <div class="col-5">
          <div class="updated_value">{{ new_values.last_permanent_employer }}</div>
          <div class="old_value">{{ old_values.last_permanent_employer }}</div>
        </div>
      </div>
      <div v-if="new_values !== null && 'sick_pay' in new_values" class="row">
        <div class="col-7"><strong>Entitled to : Sick Pay</strong></div>
        <div class="col-5">
          <div class="updated_value">{{ new_values.sick_pay }}</div>
          <div class="old_value">{{ old_values.sick_pay }}</div>
        </div>
      </div>
      <div v-if="new_values !== null && 'holiday_entitlement' in new_values" class="row">
        <div class="col-7"><strong>Entitled to : Holiday</strong></div>
        <div class="col-5">
          <div class="updated_value">{{ new_values.holiday_entitlement }}</div>
          <div class="old_value">{{ old_values.holiday_entitlement }}</div>
        </div>
      </div>
      <div v-if="new_values !== null && 'work_place_pension' in new_values" class="row">
        <div class="col-7"><strong>Entitled to : Work Place Pension</strong></div>
        <div class="col-5">
          <div class="updated_value">{{ new_values.work_place_pension }}</div>
          <div class="old_value">{{ old_values.work_place_pension }}</div>
        </div>
      </div>
      <div v-if="new_values !== null && 'maternity_paternity' in new_values" class="row">
        <div class="col-7"><strong>Entitled to : Maternity / Paternity</strong></div>
        <div class="col-5">
          <div class="updated_value">{{ new_values.maternity_paternity }}</div>
          <div class="old_value">{{ old_values.maternity_paternity }}</div>
        </div>
      </div>
      <div v-if="new_values !== null && 'paid_training' in new_values" class="row">
        <div class="col-7"><strong>Received : Paid Training</strong></div>
        <div class="col-5">
          <div class="updated_value">{{ new_values.paid_training }}</div>
          <div class="old_value">{{ old_values.paid_training }}</div>
        </div>
      </div>
      <div v-if="new_values !== null && 'restrict_other_work' in new_values" class="row">
        <div class="col-7"><strong>Restricted from performing other work</strong></div>
        <div class="col-5">
          <div class="updated_value">{{ new_values.restrict_other_work }}</div>
          <div class="old_value">{{ old_values.restrict_other_work }}</div>
        </div>
      </div>
      <div v-if="new_values !== null && 'own_money_on_training' in new_values" class="row">
        <div class="col-7"><strong>Spent own money on training</strong></div>
        <div class="col-5">
          <div class="updated_value">{{ new_values.own_money_on_training }}</div>
          <div class="old_value">{{ old_values.own_money_on_training }}</div>
        </div>
      </div>
      <div v-if="new_values !== null && 'provide_own_equipment' in new_values" class="row">
        <div class="col-7"><strong>Provide own equipment</strong></div>
        <div class="col-5">
          <div class="updated_value">{{ new_values.provide_own_equipment }}</div>
          <div class="old_value">{{ old_values.provide_own_equipment }}</div>
        </div>
      </div>
    </div>

    <!-- FILES -->
    <div v-if="log.log_type === 'worker' && log.type === 'created' && model_log === 'File' && new_values !== null" class="record">
      <div class="row">
        <div class="col-5"><strong>File Type Uploaded</strong></div>
        <div class="col-7">
          <span v-if="new_values.type === 'id_1'">ID 1</span>
          <span v-if="new_values.type === 'id_2'">ID 2</span>
          <span v-if="new_values.type === 'contract'">Contract</span>
          <span v-if="new_values.type === 'application'">Application</span>
          <span v-if="new_values.type === 'vat_cert'">VAT Certificate</span>
          <span v-if="new_values.type === 'pe_ins_cert'">PE Insurance Certificate</span>
          <span v-if="new_values.type === 'pi_ins_cert'">PI Insurance Certificate</span>
          <span v-if="new_values.type === 'other_1'">Other 1</span>
          <span v-if="new_values.type === 'other_2'">Other 2</span>
        </div>
      </div>
    </div>
    <div v-if="log.log_type === 'worker' && log.type === 'deleted' && model_log === 'File' && new_values !== null && old_values !== null" class="record">
      <div class="row">
        <div class="col-5"><strong>File Type Deleted</strong></div>
        <div class="col-7">
          <span v-if="old_values.type === 'id_1'">ID 1</span>
          <span v-if="old_values.type === 'id_2'">ID 2</span>
          <span v-if="old_values.type === 'contract'">Contract</span>
          <span v-if="old_values.type === 'application'">Application</span>
          <span v-if="old_values.type === 'vat_cert'">VAT Certificate</span>
          <span v-if="old_values.type === 'pe_ins_cert'">PE Insurance Certificate</span>
          <span v-if="old_values.type === 'pi_ins_cert'">PI Insurance Certificate</span>
          <span v-if="old_values.type === 'other_1'">Other 1</span>
          <span v-if="old_values.type === 'other_2'">Other 2</span>
        </div>
      </div>
    </div>

    <!-- RECRUITMENT -->
    <div v-if="log.log_type === 'worker' && log.type === 'created' && model_log === 'Recruitment Info' && new_values !== null" class="record"></div>

    <!-- SERVICES -->
    <div v-if="log.log_type === 'worker' && log.type === 'created' && model_log === 'Services' && new_values !== null" class="record">
      <div v-if="new_values.personal_accident_insurance !== null" class="row">
        <div class="col-5"><strong>Personal Accident Ins.</strong></div>
        <div class="col-7">
          <span v-if="new_values.personal_accident_insurance">Yes</span>
          <span v-else-if="!new_values.personal_accident_insurance">No</span>
        </div>
      </div>
      <div v-if="new_values.genius_tax !== null" class="row">
        <div class="col-5"><strong>Genius Tax</strong></div>
        <div class="col-7">
          <span v-if="new_values.genius_tax">Yes</span>
          <span v-else-if="!new_values.genius_tax">No</span>
        </div>
      </div>
    </div>
    <div v-if="(log.type === 'deleted' || log.type === 'restored' || log.type === 'updated') && model_log === 'Services' && new_values !== null && old_values !== null" class="record">
      <div v-if="new_values !== null && 'personal_accident_insurance' in new_values" class="row">
        <div class="col-5"><strong>Personal Accident Ins.</strong></div>
        <div class="col-7">
          <div class="updated_value">
            <span v-if="new_values.personal_accident_insurance">Yes</span>
            <span v-else-if="!new_values.personal_accident_insurance">No</span>
          </div>
          <div class="old_value">
            <span v-if="old_values.personal_accident_insurance">Yes</span>
            <span v-else-if="!old_values.personal_accident_insurance">No</span>
          </div>
        </div>
      </div>
      <div v-if="new_values !== null && 'genius_tax' in new_values" class="row">
        <div class="col-5"><strong>Genius Tax</strong></div>
        <div class="col-7">
          <div class="updated_value">
            <span v-if="new_values.genius_tax">Yes</span>
            <span v-else-if="!new_values.genius_tax">No</span>
          </div>
          <div class="old_value">
            <span v-if="old_values.genius_tax">Yes</span>
            <span v-else-if="!old_values.genius_tax">No</span>
          </div>
        </div>
      </div>
    </div>

    <!-- TAX RETURNS -->
    <div v-if="log.log_type === 'worker' && log.type === 'created' && model_log === 'Tax Return' && new_values !== null" class="record">
      <div class="row">
        <div class="col-5"><strong>Tax Return for Year</strong></div>
        <div class="col-7">{{ new_values.return_for_year }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "worker",
  props: {log: null, model_log: null},
  data() {
    return {
      tempFileDeletedLog: {},
      new_values: null,
      old_values: null
    }
  },
  beforeMount() {
    this.new_values = this.unserialize(this.log.new_values)
    if (this.log.old_values !== null) {
      this.old_values = this.unserialize(this.log.old_values)
    }
    if (this.model_log === 'File' && this.log.type === 'deleted' && this.log.log_type === 'worker') {
      this.tempFileDeletedLog = JSON.parse(this.log.new_values)
    }
  },
  methods: {
    unserialize(data){
      // Takes a string representation of variable and recreates it
      //
      // version: 810.114
      // discuss at: http://phpjs.org/functions/unserialize
      // +     original by: Arpad Ray (mailto:arpad@php.net)
      // +     improved by: Pedro Tainha (http://www.pedrotainha.com)
      // +     bugfixed by: dptr1988
      // +      revised by: d3x
      // +     improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
      // %            note: We feel the main purpose of this function should be to ease the transport of data between php & js
      // %            note: Aiming for PHP-compatibility, we have to translate objects to arrays
      // *       example 1: unserialize('a:3:{i:0;s:5:"Kevin";i:1;s:3:"van";i:2;s:9:"Zonneveld";}');
      // *       returns 1: ['Kevin', 'van', 'Zonneveld']
      // *       example 2: unserialize('a:3:{s:9:"firstName";s:5:"Kevin";s:7:"midName";s:3:"van";s:7:"surName";s:9:"Zonneveld";}');
      // *       returns 2: {firstName: 'Kevin', midName: 'van', surName: 'Zonneveld'}

      var error = function (type, msg, filename, line){throw new window[type](msg, filename, line);};
      var read_until = function (data, offset, stopchr){
        var buf = [];
        var chr = data.slice(offset, offset + 1);
        var i = 2;
        while(chr != stopchr){
          if((i+offset) > data.length){
            error('Error', 'Invalid');
          }
          buf.push(chr);
          chr = data.slice(offset + (i - 1),offset + i);
          i += 1;
        }
        return [buf.length, buf.join('')];
      };
      var read_chrs = function (data, offset, length){
        var buf = [];
        for(var i = 0;i < length;i++){
          var chr = data.slice(offset + (i - 1),offset + i);
          buf.push(chr);
        }
        return [buf.length, buf.join('')];
      };
      var _unserialize = function (data, offset){
        if(!offset) offset = 0;
        var buf = [];
        var dtype = (data.slice(offset, offset + 1)).toLowerCase();

        var dataoffset = offset + 2;
        var typeconvert = new Function('x', 'return x');
        var chrs = 0;
        var datalength = 0;

        switch(dtype){
          case "i":
            typeconvert = new Function('x', 'return parseInt(x)');
            var readData = read_until(data, dataoffset, ';');
            var chrs = readData[0];
            var readdata = readData[1];
            dataoffset += chrs + 1;
            break;
          case "b":
            typeconvert = new Function('x', 'return (parseInt(x) == 1)');
            var readData = read_until(data, dataoffset, ';');
            var chrs = readData[0];
            var readdata = readData[1];
            dataoffset += chrs + 1;
            break;
          case "d":
            typeconvert = new Function('x', 'return parseFloat(x)');
            var readData = read_until(data, dataoffset, ';');
            var chrs = readData[0];
            var readdata = readData[1];
            dataoffset += chrs + 1;
            break;
          case "n":
            readdata = null;
            break;
          case "s":
            var ccount = read_until(data, dataoffset, ':');
            var chrs = ccount[0];
            var stringlength = ccount[1];
            dataoffset += chrs + 2;

            var readData = read_chrs(data, dataoffset+1, parseInt(stringlength));
            var chrs = readData[0];
            var readdata = readData[1];
            dataoffset += chrs + 2;
            if(chrs != parseInt(stringlength) && chrs != readdata.length){
              error('SyntaxError', 'String length mismatch');
            }
            break;
          case "a":
            var readdata = {};

            var keyandchrs = read_until(data, dataoffset, ':');
            var chrs = keyandchrs[0];
            var keys = keyandchrs[1];
            dataoffset += chrs + 2;

            for(var i = 0;i < parseInt(keys);i++){
              var kprops = _unserialize(data, dataoffset);
              var kchrs = kprops[1];
              var key = kprops[2];
              dataoffset += kchrs;

              var vprops = _unserialize(data, dataoffset);
              var vchrs = vprops[1];
              var value = vprops[2];
              dataoffset += vchrs;

              readdata[key] = value;
            }

            dataoffset += 1;
            break;
          default:
            error('SyntaxError', 'Unknown / Unhandled data type(s): ' + dtype);
            break;
        }
        return [dtype, dataoffset - offset, typeconvert(readdata)];
      };
      return _unserialize(data, 0)[2];
    }
  }
}
</script>
